/* INEWER back-to-top button — 2026-08-11 */
(() => {
  function initBackToTop() {
    const button = document.querySelector('[data-inewer-back-to-top]');
    if (!button || button.dataset.inewerBackToTopReady === 'true') return;

    button.dataset.inewerBackToTopReady = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let ticking = false;

    const updateButton = () => {
      const threshold = Math.max(600, window.innerHeight * 0.85);
      const visible = window.scrollY > threshold;

      button.classList.toggle('is-visible', visible);
      button.setAttribute('aria-hidden', visible ? 'false' : 'true');
      button.tabIndex = visible ? 0 : -1;
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateButton);
    };

    button.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    updateButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackToTop, { once: true });
  } else {
    initBackToTop();
  }

  document.addEventListener('shopify:section:load', initBackToTop);
})();
